const common = {
  Test: 'Test',
};

export default common;
